import calendar from "../../../../assets/Images/dashboard/calendar.png";
import business from "../../../../assets/Images/dashboard/business.png";
import capitalexpenditure from "../../../../assets/Images/dashboard/capital-expenditure.png";
import pollution from "../../../../assets/Images/dashboard/pollution.png";
import upArrow from "../../../../assets/Images/dashboard/up-arrow.png";
import roi from "../../../../assets/Images/dashboard/ROI.png";
import { Constants } from "constants/constant";



// Base years array
export const baseYears = Array.from({ length: 37 }, (_, index) => 2015 + index);

// Target years array
export const targetYears = Array.from({ length: 28 }, (_, index) => 2024 + index);

const UNIT_TCO2E=Constants.UNIT_TCO2E;

// Scopes covered options array
export const scopesCoveredOptions = [
  { id: 1, label: "Scope 1", value: "Scope 1" },
  { id: 2, label: "Scope 2", value: "Scope 2" },
  { id: 3, label: "Scope 3", value: "Scope 3" },
];

export const ProjectRegisterOptions = [
  {
    id: 0,
    label: "Marginal Abatement Cost",
    value: "Marginal Abatement Cost",
  },
  {
    id: 1,
    label: "Decarbonization Pathway",
    value: "Decarbonization Pathway",
  },
  {
    id: 2,
    label: "Decarbonization Waterfall",
    value: "Decarbonization Waterfall",
  },
  {
    id: 3,
    label: "Target Trajectory",
    value: "Target Trajectory",
  }
];

export const metrics = [
  { id: 0, label: `Annual Emissions Reduction (${UNIT_TCO2E})`,key:'emissionReduction', value: 0,src:pollution,isCurrency: false },
  { id: 1, label: "Annual NPV",key:'annualNPV', value: 0,src:calendar,isCurrency: true },
  { id: 2, label: "CAPEX Investment",key:'capexInvestment', value: 0,src:capitalexpenditure,isCurrency: true },
  { id: 3, label: "OPEX Investment", key:'opexInvestment',value: 0,src:business,isCurrency: true },
  { id: 4, label: `Marginal Abatement Cost(${UNIT_TCO2E})`,key:'mac', value: 0 ,src:upArrow,isCurrency: true },
  { id: 5, label: "Average Annual ROI(%)",key:'averageAnnualRoi', value: 0 ,src:roi,isCurrency: false, isAverageAnnualRoiPresent: true },
  { id: 6, label: "ROI(%)",key:'roi', value: 0 ,src:roi,isCurrency: false },
];

// Scopes covered options array
export const businessUnitOptions = [
  { id: 1, label: "Unit 1", value: "01" },
  { id: 2, label: "Unit 2", value: "02" },
  { id: 3, label: "Unit 3", value: "03" },
  { id: 4, label: "Unit 4", value: "04" },
  { id: 5, label: "Unit 5", value: "05" },
];

export const scenarioOptions = [
  { id: 1, label: "Plan A", value: "Plan A" },
  { id: 2, label: "Plan B", value: "Plan B" },
  { id: 3, label: "Plan C", value: "Plan C" },
  { id: 4, label: "Plan D", value: "Plan D" },
  { id: 5, label: "Plan E", value: "Plan E" },
];
